export { default } from './ResumeHoldButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/ResumeHoldButton/index.js